exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "main[_v-a84fbb1a]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}section[_v-a84fbb1a]{-ms-flex:1;flex:1}#scroll-tab[_v-a84fbb1a]{overflow-y:auto}.mdl-menu[_v-a84fbb1a]{scrollbar-width:thin;scrollbar-color:#f19100 #e3e3e3}.mdl-menu[_v-a84fbb1a]::-webkit-scrollbar{width:5px;height:5px;background-color:#e3e3e3}.mdl-menu[_v-a84fbb1a]::-webkit-scrollbar-thumb{background-color:#f19100}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-a84fbb1a&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/App.vue
// module id = 321
// module chunks = 0